import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { TutorsState } from '@/store/tutors/types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const Tutors: Module<TutorsState, RootState> = {
  state,
  mutations,
  actions,
  getters,
};

export default Tutors;
